var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.500000, 1.500000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5315,0 C3.38925,0 0.0315,3.35775 0.0315,7.5 C0.0315,11.64225 3.38925,15 7.5315,15 C11.67375,15 15.0315,11.64225 15.0315,7.5 C15.0315,3.35775 11.673,0 7.5315,0 Z M6.969,11.8125 L3.219,9 L4.344,7.5 L6.594,9.1875 L10.5315,3.9375 L12.0315,5.0625 L6.969,11.8125 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.68fe41a9960db38a65a01d65ca9570cc.svg";
export { ForwardRef as ReactComponent };